import { useFetch } from '../../../hooks/useFetch';
import { errorNotification } from '../../../providers/mantine-notifications';
import { translateServerHttpErrors } from '../../../utils/helpers';
import {
  GenerateUnifiedReceiptParams,
  generateUnifiedReceiptRequest,
} from '../../unified-receipts';

export type UseGenerateUnifiedReceiptProps = {
  data: GenerateUnifiedReceiptParams;
  onSuccess: (response: Blob) => void;
};

export function useGenerateUnifiedReceipt() {
  const {
    fetchData,
    state: { data: response, error, loading },
  } = useFetch<Blob>();

  const fetch = ({ data, onSuccess }: UseGenerateUnifiedReceiptProps) =>
    fetchData({
      fetcher: () => generateUnifiedReceiptRequest(data),
      onError: (error: any) => {
        errorNotification({
          title: 'Erro ao gerar recibo unificado',
          message: translateServerHttpErrors(error, 'Tente novamente.'),
        });
      },
      onSuccess,
    });

  return {
    fetch,
    response,
    error,
    loading,
  };
}

import {
  PreviewUnifiedReceiptResponse,
  previewUnifiedReceiptRequest,
} from '../../unified-receipts';

export type UsePreviewUnifiedReceiptProps = {
  data: GenerateUnifiedReceiptParams;
  onSuccess: (response: PreviewUnifiedReceiptResponse) => void;
};

export function usePreviewUnifiedReceipt() {
  const {
    fetchData,
    state: { data: response, error, loading },
  } = useFetch<PreviewUnifiedReceiptResponse>();

  const fetch = ({ data, onSuccess }: UsePreviewUnifiedReceiptProps) =>
    fetchData({
      fetcher: () => previewUnifiedReceiptRequest(data),
      onError: (error: any) => {
        errorNotification({
          title: 'Erro ao gerar preview unificado',
          message: translateServerHttpErrors(error, 'Tente novamente.'),
        });
      },
      onSuccess,
    });

  return {
    fetch,
    response,
    error,
    loading,
  };
}
